import {
  ContentChild,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';

@Directive({ selector: '[appTooltipDirective]' })
export class TooltipDirective {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private viewContainerRef = inject(ViewContainerRef);

  @Input() public parametroPlantilla: TemplateRef<unknown>;
  @Output() public shown = new EventEmitter();

  @ContentChild('tooltipTemplate') private tooltipTemplateRef: TemplateRef<object>;

  private tooltipId: string;
  private visible: boolean;

  constructor() {
    this.visible = false;
  }

  @HostListener('mouseenter') public onMouseEnter(): void {
    const view = this.viewContainerRef.createEmbeddedView(this.tooltipTemplateRef);
    view.rootNodes.forEach((node) => this.renderer.appendChild(this.elementRef.nativeElement, node));
    this.visible = true;
    this.shown.emit();
  }

  @HostListener('mouseleave') public onMouseLeave(): void {
    if (this.viewContainerRef) {
      this.viewContainerRef.clear();
    }
    this.visible = false;
  }

  @HostListener('click') public onClick(): void {
    if (this.visible) {
      if (this.viewContainerRef) {
        this.viewContainerRef.clear();
      }
      this.visible = false;
    } else {
      const view = this.viewContainerRef.createEmbeddedView(this.tooltipTemplateRef);
      view.rootNodes.forEach((node) => this.renderer.appendChild(this.elementRef.nativeElement, node));
      this.visible = true;
    }
  }
}
